const config = {
    "secretKey": "$Hj7aF#k9l*D@v!3G",
    "numberOfRows": 100,
    "authMethod": "JWT",
    "endPoint":  `https://${window.location.host}/MillAI_BE`, 
    //"endPoint": "https://pwbi-internal.dev.local/MillAI_BE_Premium", 
    //"endPoint": "https://localhost:7237", 
    "subDir" : "/",
    "imgAllowed": true,
    "msgReviewsAllowed" : true,
    "jwtAllowed": true,
    "adAllowed" : false,
    "adConfig": {
      "clientId": "",
      "authority": "",
      "redirectUri": ""
    }
  }

  export default config;
